export const API_BASE_URL = "/api/v2";
export const ENDPOINTS_BASE_URL = "_ah/api";

export const activityTemplateUrl = {
  BASE_URL: "/activitytemplate",
  SAVE_URL: "/save",
  LOAD_URL: "/load",
  LOAD_ALL_URL: "/load/all",
  DELETE_URL: "/remove",
  SAVE_DEADLINE_ACTIVITIES: "/save/deadline",
  SAVE_HEARING_ACTIVITIES: "/save/hearing",
};

export const alerts = {
  BASE_URL: "/alerts",
  BASE_ENDPOINTS_URL: "/alerts/v1",
  QUERY: "/query",
  COUNT: "/count",
  COUNT_ALL: "/count-all",
  DELETE_ALERT: "/:alertId/user/:userId",
  HONORARY_POSTPONE: "/:alertId/honorary-postpone/:days/user/:userId",
  BIRTHDAY: "/birthday",
  SEND_EMAIL: "/send-email",
};

export const appointment = {
  BASE_URL: "/appointments",
  CHANGE_RESPONSIBLE: "/responsible",
  CHANGE_STATUS: "/status",
  RESCHEDULE: "/reschedule",
  HAS_CUSTOMER_NOTIFICATION: "/has-customer-notification",
  POSTPONE: "/:appointmentId/postpone/:timeInt/user/:userId",
};

export const batchActions = {
  BASE_URL: "/batch-action",
  ENQUEUE: "/enqueue",
};

export const bills = {
  BASE_URL: "/billing",
  BASE_ENDPOINTS_URL: "/billing/v1",
  LOAD_BILLS_AND_QUERY: "/loadBillsAndQuery",
  APPLY_BILLS_FILTER: "/applyBillsFilter",
  DISMOUNT_BILL: "/dismountBill",
  GET_BILL: "/getBill",
  UPDATE_DUE_DATE: "/change-due-date",
  PRINT_REPORT: "/getReportBillingParams",
  GET_INFO: "/getUserPlanBilling",
  UPDATE_INFO: "/saveUserPlanBilling?alt=json",
};

export const calendar = {
  ENDPOINTS_URL: "/calendar/v1",
  LOAD_APPOINTMENT: "/loadEditAppointment",
  SAVE_APPOINTMENT: "/saveAppointment",
  DELETE_APPOINTMENT: "/deleteAppointment",
  REMOVE_TAG_FROM_APPOINTMENT: "/removeTagFromAppointment",
  ADD_TAG_TO_APPOINTMENT: "/addTagToAppointment",
  SAVE_RESCHEDULE_APPOINTMENT_REMINDER: "/saveRescheduledAppointmentReminder",
  SAVE_RESCHEDULE_APPOINTMENT: "/saveRescheduledAppointment",
  GET_CALENDAR_LAST_VIEW_AND_QUERY: "/getCalendarLastViewAndQuery",
  SAVE_CALENDAR_LAST_VIEW_AND_QUERY: "/saveCalendarLastViewAndQuery?alt=json",
  CALENDAR_PRO: "/calendar-pro",
  HAS_EVENTS: "/hasevents",
  SUMMARY: "/summary",
  COMPLETE: "/complete",
  DASHBOARD_COUNT: "/count-status",
  NO_DATE_TASKS: "/tasks-no-date",
};

export const classificationFeedback = {
  BASE_URL: "/classification",
  FEEDBACK_ENQUEUE_URL: "/feedback/enqueue",
};

export const clippings = {
  BASE_URL: "/clippings",
  BASE_ENDPOINTS_URL: "/clippings/v1",
  QUERY_URL: "/query",
  SUMMARY_URL: "/query/summary/daily",
  ALL_SUMMARY_URL: "/query/summary/alerts",
  COUNT_URL: "/query/count",
  DISCARD_URL: "/discard/user",
  BLOCK_URL: "/block/user",
  RESET_URL: "/reset/user",
  ASSIGN_URL: "/assign",
  ASSIGN_CASE_CANDIDATE_URL: "/assignCaseCandidate",
  SCHEDULE_JOB: "schedule-job",
  STATUS_URL: "/status",
  USER_URL: "/user",
  EMPTY_STATE_URL: "/empty-state",
  SNAPSHOTS_URL: "/snapshots/user",
  LAST_WEEK_URL: "/last-week",
  EVENTS_URL: "/events/user",
  DELETE_EVENT_URL: "/delete-event",
  TOGGLE_TAG_URL: "/toggle-tag",
  CLASSIFICATION_FEEDBACK: "/classification-feedback",
  HAS_ASSIGNED: "/has-assigned",
  REMOVE_HISTORICAL: "/remove-historical",
};

export const deadline = {
  BASE_URL: "/deadlines",
  CHANGE_RESPONSIBLE: "/responsible",
  DOCUMENTS: "/:id/documents",
  TAG: "/:id/tag/:tagId",
  RESCHEDULE: "/reschedule",
  DEADLINE_DELETE: "/:deadlineId/delete",
  DEADLINE_SAVE: "/save",
  CHANGE_DEADLINE_STATUS: "/update-status",
};

export const demands = {
  BASE_URL: "/demand",
  LOAD_LIST: "/case/:caseId",
  LOAD_TYPES: "/info-types",
};

export const document = {
  BASE_URL: "/documents",
  USER: "/user",
  LIST_BY_DEADLINE: "/list/deadline",
  LIST_BY_HEARING: "/list/hearing",
};

export const enqueue = {
  BASE_URL: "/enqueue",
};

export const entries = {
  BASE_URL: "/entry",
  DELETE: "/delete",
  LIST_ENTRIES: "/query/list",
  LIST_ENTRY_HISTORY: "/list-entry-history/",
  PAST_BALANCE: "/query/past-balance",
  TOGGLE_ENTRY_STATUS: "/toggle-entry-status",
  ENTRY_MODULE_DATA: "/module-data",
};

export const financial = {
  BASE_URL: "/financial/v1",
  DELETE_THIS_AND_FUTURES: "/deleteThisAndFutures",
  TOGGLE_DONE_OPEN_ENTRY: "/toggleDoneOpenEntry",
};

export const firebase = {
  BASE_URL: "/firebase",
};

export const folder = {
  BASE_URL: "/folder",
  ENDPOINTS_URL: "/folders/v1",
  GET_CUSTOMER_INFO_BY_CASE: "/getCustomerDetailsByCase",
  STAKEHOLDER_ROLE_BY_NAME: "/getStakeholderRoleByName?name=",
  UNLINK_LAWSUIT: "/unlinkLawsuit",
  UNLINK_FOLDER: "/:id/unlink/user/:userId",
  INACTIVATE: "/inactivate",
  ADD_TAG: "/addTagToCase",
  REMOVE_TAG: "/removeTagFromCase",
  CHANGE_CUSTOMER: "/change-customer",
  UNBIND_ATTACHED: "/unbindAttached",
  HAS_FOLDER: "/hasfolder",
  CHANGE_INSTANCE: "/change-instance",
};

export const googleCredentialUrl = {
  GET_GOOGLE_CREDENTIAL_URL: "/google",
};

export const hearing = {
  BASE_URL: "/hearings",
  SAVE_HEARING: "/save",
  DELETE_HEARING: "/:hearingId/delete",
  RESCHEDULE: "/reschedule",
  DOCUMENTS: "/:id/documents",
  CHANGE_RESPONSIBLE: "/responsible",
  CHANGE_HEARING_STATUS: "/update-status",
  TAG: "/:id/tag/:tagId",
};

export const helpCenterUrl = {
  GET_HELP_CENTER_URL: "/help-center-url",
};

export const historical = {
  BASE_URL: "/historical",
  BASE_ENDPOINTS_URL: "/histories/v1",
  DELETE_URL: "/deleteHistorical",
  LOAD_URL: "/loadEditHistorical",
  SAVE_URL: "/saveHistoricalByCase",
  TAG_URL: "/tag",
  LEGACY: "/legacy",
  CHANGE_RESPONSIBLE: "/responsible",
  RESUME: "/resume",
  EVENTS: "/events",
  DELETE_EVENT: "/delete-event",
  HAS_TREATED: "/has-treated",
  USER: "/user",
};

export const incomingHistorical = {
  BASE_URL: "/incoming-histories",
  SUMARRY: "/summary",
  ALL: "/all",
  USER: "/user",
  TREAT_HISTORY: "/:historicalId/user/:userId",
};

export const log = {
  BASE_URL: "/logs",
  ENTITY_LOGS: "/entity",
  ENTITY_TYPE: "/type",
};

export const mixpanel = {
  BASE_URL: "/mixpanel-event",
};

export const office = {
  BASE_URL: "/offices",
};

export const storage = {
  BASE_URL: "/storage",
  SAVE_REFERENCE: "/save-reference",
  DOWNLOAD_FILE: "/download-file",
  DELETE_UPLOAD: "/delete-upload",
};

export const oabSearch = {
  BASE_URL: "/oab-search",
  FIRST_EXPERIENCE: "/first-experience",
};

export const pendingSearch = {
  BASE_URL: "/pending-search",
  JOB_ID: "/job-id",
  RECREATE: "/recreate",
};

export const plan = {
  BASE_URL: "/plan",
  AVAILABLE_PLANS: "/getAvailablePlans",
  USER_PLAN: "/getUserPlan",
  ACTIVATE: "/activate-light",
  HIRE: "/hire",
  EDIT: "/edit",
  USER_PLAN_RESUME: "/getUserPlanResume",
  UPDATE_TRIAL_URL: "/update-trial",
  UPDATE_PAYMENT: "/payment/update-payment",
  PAY_NOW: "/payment/pay-now",
  PLAN_FINANCIAL_RESPONSIBLES: "/plan-responsibles",
};

export const planLoader = {
  BASE_URL: "/plan-loader",
  AVAILABLE_PLANS: "/available-plans",
  PLAN_INFO: "/plan-info",
  PLAN_CHANGE_VALIDATIONS: "/plan-validations",
  PLAN_FINANCIAL_RESPONSIBLES: "/plan-responsibles",
  PAYMENT_HISTORY: "/payment/history",
  PRO_RATA_CALCULATOR: "/prorata-calculator",
};

export const pro = {
  ENDPOINTS_URL: "/pro/v1",
  LOAD_DEADLINE: "/loadDeadline",
  SAVE_DEADLINE: "/saveDeadline",
  DELETE_DEADLINE: "/deleteDeadline",
  ADD_TAG_TO_DEADLINE: "/addTagToDeadline",
  ADD_TAG_TO_HEARING: "/addTagToHearing",
  REMOVE_TAG_FROM_DEADLINE: "/removeTagFromDeadline",
  REMOVE_TAG_FROM_HEARING: "/removeTagFromHearing",
  CHANGE_DEADLINE_STATUS: "/updateDeadlineStatus",
};

export const notificationEvent = {
  ENDPOINTS_URL: "/notification-event",
  SAVE_NOTIFICATION: "/:eventType",
  LOAD_NOTIFICATION: "/:eventType/load",
  LOAD_ALL_NOTIFICATION: "/:eventType/load-all",
  RESEND_NOTIFICATION: "/:eventType/resend/:idNotification",
};

export const recurrence = {
  BASE_URL: "/recurrence",
  ENQUEUE: "/enqueue",
};

export const reminder = {
  BASE_URL: "/reminders",
  CASE_ONLY: "/case-only",
};

export const report = {
  BASE_URL: "/report",
  CLIPPING: "/clipping",
  ENTRY: "/entry",
  HONORARY: "/honorary",
};

export const responsible = {
  BASE_URL: "/suggests/v1",
  ALL_USER: "/getAllUsers",
};

export const involved = {
  BASE_URL: "/case",
  CHECK_CASE_ACCESS: "/check-involved",
};

export const tasks = {
  BASE_URL: "/tasks",
  LOAD_BY_CASE: "/case",
  LOAD_COMMENTS: "/comments",
  CHANGE_TASK_LIST: "/change-task-list",
  RESCHEDULE: "/reschedule",
  DONE_TASK: "/:taskId/user/:userId/done",
};

export const contacts = {
  BASE_URL: "/contact",
  GET_EMAILS: "/:id/emails",
  GET_SUGGESTION: "/:id/suggestion",
  REMOVE_PHOTO: "/remove-photo",
  SHARE: "/share",
  SHARE_WHATSAPP: "/share-whatsapp-customer",
  BRIEF: "/brief",
};

export const contactsV1 = {
  BASE_URL: "/contacts/v1",
  SAVE_IMAGE: "/saveImage?alt=json",
  CROP_IMAGE: "/cropImage?alt=json",
  GET_DETAIL: "/getContactDetail",
  GET_EMAIL: "/getContactEmail",
};

export const team = {
  BASE_URL: "/teams",
  LOAD_ALL: "/all",
  LOAD_ALL_ACTIVE: "/all/active",
  CHANGE_STATUS: "/status",
};

export const user = {
  BASE_URL: "/user",
  BASE_ENDPOINTS_URL: "/users/v1",
  USERS: "/users",
  EDIT_URL: "/editUser",
  SAVE_URL: "/saveUser",
  LOAD_URL: "/getById",
  CHANGE_PASSWORD: "/change-password",
  GET_ALL: "/getAllUsers",
  ACTIVATE: "/activateUser",
  DELETE: "/deleteUser",
  RE_INVITE: "/reInviteUser",
  DEACTIVATE: "/deactivateUser",
  CHANGE_STATUS_AND_REASSIGN: "/changeUserStatusAndReassign",
  ACTIVATE_COURTESY: "/activate-courtesy",
  REMOVE_CUSTOMER: "/removeCustomer",
  REGENERATE_LINK: "/regenerate-simple-access-link",
  INVITE_CLIENT: "/inviteClient",
  LOAD_CLIENT: "/loadClient",
  SAVE_CLIENT: "/saveClient",
  INVITE: "/multiple-invite",
  GET_ONLY_USERS: "/getOnlyUsers",
};

export const tenant = {
  BASE_URL: "/tenant",
  SHARE_WALL_URL: "/share-wall",
  DELETION_CONFIG: "/deletion-config/user/",
  CREDITS: "/credits",
  OFFICE_TYPE_PLAN: "/plan/no-auth",
  TRUST_UNBLOCK: "/trust-unblock",
};

export const utils = {
  BASE_URL: "/utils",
  DELETE_FILE: "/file/delete",
  IMAGE_CROP_URL: "/image/crop",
  UPLOAD_FILE: "/file/upload",
};

export const workspace = {
  BASE_URL: "/workspace/v1",
  LIST_TASK_BY_USER: "/listTaskListsByUser",
  SAVE_TASK: "/saveTaskWithList",
  LOAD_EDIT_TASK: "/loadEditTask",
  GET_TASK_WITH_COMMENTS: "/getTaskWithComments",
  DELETE_TASK: "/deleteTask",
  REMOVE_TAG_FROM_TASK: "/removeTagFromTask",
  ADD_TAG_TO_TASK: "/addTagToTask",
  CHANGE_TASK_RESPONSIBLE: "/changeTaskResponsible",
  SAVE_COMMENT: "/saveComment",
  REMOVE_COMMENT: "/removeComment",
  CHANGE_TASK_PRIORITY: "/changeTaskPriority",
  CHANGE_TASK_STATUS: "/changeTaskStatus",
  ADD_TASK_LIST: "/addTaskList",
};

export const billing = {
  BASE_URL: "/billing/v1",
  GET_ACTIVITIES: "/getActivities",
  SAVE_TIMESHEET: "/saveTimesheets",
};

export const timesheet = {
  BASE_URL: "/timesheet",
  SUMMARY: "/query/summary",
};

export const timesheetTimer = {
  BASE_URL: "/timesheet-timer",
  GET_BY_USER: "/user",
  START: "/start",
  PAUSE: "/pause",
  RESTART: "/restart",
};

export const caseList = {
  BASE_URL: "/case-list",
  PREPARE_REPORT: "/prepare-report",
};

export const cases = {
  BASE_URL: "/case",
  CUSTOMERS: "/customers",
  DELETE_CASE: "/delete",
  USER: "/user",
  DETAILS: "/details",
  TOGGLE_IMPORTANT: "/toggle-important",
  REMOVE_STAKEHOLDER: "/remove-stakeholder",
  REMOVE_CUSTOMER: "/remove-customer",
  RELATE_ATTACHED: "/relate-attached",
  TOGGLE_ACTIVATE_INACTIVATE: "/toggle-activate-inactivate-case",
  GET_ATTACHED: "/attacheds",
  EVENTS: "/events/user",
  CONTACTS_EXPORT: "/:caseId/contact/export/user/:userId",
};

export const appealIncident = {
  BASE_URL: "/appeal-incident",
  CHILDREN_SUM: "/children-summary",
  ROOT_CASE_INFO: "/root-case-info",
};

export const documentModel = {
  BASE_URL: "/documents-model",
  SAVE_DOCS_FILLED: "/docs/filled",
};

export const costCenterUrl = {
  BASE_URL: "/cost-center",
  LIST_ALL_URL: "/all",
};

export const accreditationUrl = {
  BASE_URL: "/accreditation",
  SAVE: "/save",
  LOAD: "/load",
  INACTIVATE: "/inactivate",
  TOGGLE_BILLING_RULER: "/toggle-billing-ruler",
};

export const bankUrl = {
  BASE_URL: "/banks",
  LOAD: "/load",
};

export const bankSlipUrl = {
  BASE_URL: "/bankslip",
  PRINT_URL: "/print",
  HAS_CUSTOMER_EMAIL: "/has-customer-email",
  PRINT_BATCH_URL: "/print/batch",
  ENTRY_URL: "/entry",
};

export const accountUrl = {
  BASE_URL: "/accounts",
};

export const addressUrl = {
  BASE_URL: "/address",
  LOAD: "/:zipCode",
};

export const countryUrl = {
  BASE_URL: "/countries",
};

export const clippingSearch = {
  BASE_URL: "/clipping-search",
  LOAD: "/load",
  LIST: "/list",
  CONFIG: "/clippings-config",
  USER: "/user",
  HAS_SLOTS_USED: "/has-slots-used",
  ENQUEUE: "/enqueue",
  CLIPPING_SEARCH_ID_RECEIVERS: "/:clippingSearchId/receivers",
};

export const comment = {
  BASE_URL: "/comments",
  USER: "/user",
  ORIGIN: "/origin",
  ORIGIN_ID: "/originId",
};

export const userInfo = {
  BASE_URL: "/shared/v1",
  BASE_URL_V2: "/user-config/:userId",
  IS_EMAIL_ALREADY_REGISTERED: "/isEmailAlreadyRegistered",
  FIRST_XP_CONFIG: "/firstxp-config",
};

export const userNotification = {
  BASE_URL: "/shared/v1",
  GET_NOTIFICATIONS_INFO: "/getNotificationsInfo",
  UPDATE_MOVEMENT_NOTIFICATION: "/updateNotificationConfigMovement",
  UPDATE_CALENDAR_NOTIFICATION: "/updateNotificationConfigCalendar",
  UPDATE_APPOINTMENT_NOTIFICATION: "/updateNotificationConfigAppointmentsReminder",
  UPDATE_DELAYED_NOTIFICATION: "/updateNotificationConfigDelayedTasks",
  UPDATE_CLIPPING_NOTIFICATION: "/updateClippingsEmailNotifications",
  UPDATE_FINANCIAL_NOTIFICATION: "/updateFinancialNotifications",
  UPDATE_DELEGATED_TASKS_NOTIFICATION: "/updateDelegatedTasksNotifications",
  UPDATE_LAWSUIT_INACTIVE_NOTIFICATION: "/updateLawsuitInactiveNotifications",
  UPDATE_BANK_SLIP_NOTIFICATION: "/updateBankSlipNotification",
  UPDATE_INCLUDE_PUBLIC_LAWSUIT_MOVEMENT: "/updateNotificationIncludePublicLawsuitMovement",
  UPDATE_INCLUDE_INVOLVED_LAWSUIT_MOVEMENT: "/updateNotificationIncludeInvolvedLawsuitMovement",
};

export const recessPeriod = {
  BASE_URL: "/recess-period",
  CALCULATE: "/calculate",
};

export const subpoenaSearch = {
  BASE_URL: "/court-subpoena-search",
  ENQUEUE: "/enqueue",
  RECEIVERS: "/receivers",
  USED_COURTS: "/used-courts",
  LIST_ERROR: "/errors/user",
  USER: "/user",
  UPDATE_CREDENTIALS: "/update-credentials",
};

export const searchParams = {
  BASE_URL: "/search-params",
  LAWSUIT_COURT: "/lawsuit/court",
  SUBPOENA_COURT: "/subpoena/court",
};

export const honorary = {
  BASE_URL: "/honoraries",
  SUMMARY: "/query/summary",
};

export const expense = {
  BASE_URL: "/expenses",
  SUMMARY: "/query/summary",
};

export const timezone = {
  BASE_URL: "/shared/v1",
  GET_CALENDAR_SYNC_TIMEZONES: "/getCalendarSyncTimezones",
  UPDATE_CALENDAR_SYNC_TIMEZONE: "/updateCalendarSyncTimezone",
  GET_CALENDAR_SYNC_TIMEZONE: "/getCalendarSyncTimezone",
  GET_CALENDAR_SYNC_URL: "/getCalendarSyncUrl",
};

export const recaptcha = {
  BASE_URL: "/recaptcha",
  VALIDATE_TOKEN: "/validate",
};

export const statistics = {
  BASE_URL: "/statistics",
  CASE: "/case",
};

export const whatsapp = {
  API_BASE_URL: "https://wa.me",
  WEB_BASE_URL: "https://web.whatsapp.com/send",
};

export const maps = {
  BASE_URL: "http://maps.google.com/",
};

export const aasp = {
  BASE_URL: "/aasp-clipping-search",
  LIST: "/all",
  SLOTS_AVAILABLE: "/slots-available",
  SLOTS_USED: "/slots-used",
};

export const electronicSubpoena = {
  BASE_URL: "/court-subpoena-search",
  USER: "/user",
  DOCUMENT_URL: "/document",
  DELETE_SEARCH: "/:id/user/:userId",
};

export const publicRoutes = {
  BASE_URL: "/pub/v1",
};

export const session = {
  BASE_URL: "/session",
  LOGIN_AS_USER: "/login/user",
};

export const dashboard = {
  BASE_URL: "/dashboards",
  CHART_ALL: "/chart/all",
  CHART: "/chart",
};

export const suggests = {
  BASE_URL: "/suggests",
  SEARCH_URL: "/search",
  SEARCH_OBJECT_URL: "/public-search",
};

export const shared = {
  BASE_URL: "/shared/v1",
};

export const cna = {
  BASE_URL: "/cna",
};

export const contract = {
  BASE_URL: "/contract",
  RELEASE: "/release",
  SLOTS: "/slots/:amount",
};

export const analyticEvent = {
  BASE_URL: "/analytical-event",
};

export const persesSearch = {
  SEARCH: "/search",
  TOKEN: "/token",
  CALENDAR: {
    COUNTER: "/count",
    DATE_HISTOGRAM: "/date-histogram",
  },
  LAWSUIT: {
    UPDATES: "/date-range",
    TRACKER_LINE: "/date-histogram",
    COUNTER: "/custom-count",
    ACTIVE_COUNT: "/count",
  },
};

export const automaticHistoriesFeedBack = {
  HISTORICAL: "/historical",
  FEEDBACK: "/movement-feedback",
};

export const purchase = {
  BASE_URL: "/purchase",
  TAXES_RETENTION: "/taxes-retention",
};

export const coupon = {
  BASE_URL: "/discount-coupon",
  HIRE: "/hire",
  PURCHASE: "/purchase",
};
